import { Navigate, Outlet, useLocation } from "react-router";
import { useSession } from "./useSession";

export function ProtectedRoute() {
  const { status, isAuthenticated } = useSession();
  const location = useLocation();

  if (status === "idle" || status === "loading") {
    return (
      <div role="status" aria-live="polite" style={{ padding: 24 }}>
        Загрузка…
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
